import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type PresortExamQuestionsMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  firstCriterion?: Types.InputMaybe<Types.PresortInput>;
  secondCriterion?: Types.InputMaybe<Types.PresortInput>;
  thirdCriterion?: Types.InputMaybe<Types.PresortInput>;
  scramblingA?: Types.InputMaybe<Types.Scalars['String']>;
  scramblingB?: Types.InputMaybe<Types.Scalars['String']>;
  randomize?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type PresortExamQuestionsMutation = { __typename?: 'Mutation', presortExamQuestions?: { __typename?: 'PresortExamQuestionsPayload', examQuestionsGroups?: Array<{ __typename?: 'ExamQuestionGroup', id: number }> | null } | null };

export const PresortExamQuestionsDocument = gql`
    mutation PresortExamQuestions($id: Int!, $firstCriterion: PresortInput, $secondCriterion: PresortInput, $thirdCriterion: PresortInput, $scramblingA: String, $scramblingB: String, $randomize: Boolean) {
  presortExamQuestions(
    id: $id
    firstCriterion: $firstCriterion
    secondCriterion: $secondCriterion
    thirdCriterion: $thirdCriterion
    scramblingA: $scramblingA
    scramblingB: $scramblingB
    randomize: $randomize
  ) {
    examQuestionsGroups {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PresortExamQuestionsGQL extends Apollo.Mutation<PresortExamQuestionsMutation, PresortExamQuestionsMutationVariables> {
    document = PresortExamQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }